import { Component, OnInit, Input } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import {PanelOutputLockingStatus} from '../../core/models/panel-output-locking-status';
import { SharedState } from '../../core/store/shared/shared.state';

@Component({
  selector: 'app-output-locking-status',
  templateUrl: './output-locking-status.component.html',
  styleUrls: ['./output-locking-status.component.scss']
})
export class OutputLockingStatusComponent implements OnInit {
  @Select(SharedState.isDarkTheme) isDarkTheme$: Observable<boolean>;

  @Input() status: PanelOutputLockingStatus | string;
  @Input() isLocking: boolean;
  @Input() isUnlocking: boolean;
  @Input() showOnlyIcons: boolean;
  @Input() showOnlyText: boolean;

  outputStatus = PanelOutputLockingStatus;
  constructor() { }

  ngOnInit() {
  }

}
